<template>
  <div class="export-btn text-muted d-flex align-items-center justify-content-center">
    <b-icon class="mr-2" icon="download" />
    <span @click="$emit('click')">Download CSV</span>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UeExportButton',
  emits: ['click'],
})
</script>

<style lang="sass" scoped>
.export-btn
  font-size: 0.8rem
  cursor: pointer
</style>
